import React from 'react'
import { ExecuteOperationOnPipe, ModelWithForm, TriggerPipelineOnFormSubmit } from '@morningtrain/react-resources'
import * as UI from 'ui'
import { ButtonWrap, Card, SpaceBetween, SubmitButton } from 'ui'
import * as Fields from 'support/fields'
import { Pipeline } from '@morningtrain/react-helpers'
import { Translation } from '@morningtrain/react-translations'
import * as Icons from 'ui/icons'
import { Fieldset } from 'layouts'
import { Repeater } from '@morningtrain/react-fields-repeater-field'

export default function ChecklistTemplateEditForm ({ checklistId, onClick = () => {}, children }) {
  return (
    <ModelWithForm resourceName='checklists.checklist_templates' id={checklistId}>
      <Card>
        <SpaceBetween>
          <a className='text-sm whitespace-no-wrap text-gray-400 hover:text-primary-500 inactive' onClick={onClick}>
            <UI.Button className='mb-4'>
              <Icons.ArrowLeft className='mr-2' />
              <span><Translation name='to_overview' /></span>
            </UI.Button>
          </a>
          <SubmitButton>
            <Translation name='generic.save' />
          </SubmitButton>
        </SpaceBetween>
        <Fieldset cols={1}>
          <Fields.Input name='name' />
        </Fieldset>
        <Fieldset cols={3}>
          <Fields.ResourceSelector
            name='department_id'
            optionsKey='name'
            resourceName='departments'
            multiple={false}
          />
          <Fields.Select enum='checklist_type' name='type' />
          <Fields.Select enum='employment_type_category' name='employment_category' />
        </Fieldset>
        <Fieldset cols={2}>
          <Fields.Time name='time' fromName='time_string' parseFormat='HH:mm:ss' />
          <Fields.Checkbox name='active' />
        </Fieldset>
        <Repeater
          name='fields'
          buttonClass='btn btn-sq btn-primary'
          addLabel={<Icons.Plus className='w-3 h-3' />}
          removeLabel={<Icons.Trash className='w-4 h-4' />}
        >
          <Fields.Input name='label' />
          <Fields.Input name='description' />
        </Repeater>
        <Pipeline>
          <TriggerPipelineOnFormSubmit />
          <ExecuteOperationOnPipe operationName='index' />
        </Pipeline>
        <ButtonWrap>
          <SubmitButton>
            <Translation name='generic.save' />
          </SubmitButton>
        </ButtonWrap>
      </Card>
      {children}
    </ModelWithForm>
  )
}
